import { render, staticRenderFns } from "./StaffReportTab.vue?vue&type=template&id=784e47f6&scoped=true&"
import script from "./StaffReportTab.vue?vue&type=script&lang=js&"
export * from "./StaffReportTab.vue?vue&type=script&lang=js&"
import style0 from "./StaffReportTab.vue?vue&type=style&index=0&id=784e47f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784e47f6",
  null
  
)

export default component.exports